import { render, staticRenderFns } from "./IncidentData.vue?vue&type=template&id=6499bc86"
import script from "./IncidentData.vue?vue&type=script&lang=js"
export * from "./IncidentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports